import { Badge, HStack, Icon, LinkBox, LinkOverlay, SimpleGrid, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom'
import { visibleModules } from '../../modules/registry'
import { useProductTier } from '../../hooks/useClientConfig'

export function ModuleTileGrid() {
  const tier = useProductTier()
  return (
    <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap={4}>
      {visibleModules(tier).map((mod) => (
        <LinkBox
          key={mod.id}
          bg="surface"
          p={5}
          borderRadius="lg"
          shadow="md"
          border="1px"
          borderColor="gray.200"
          _hover={{ shadow: 'lg', borderColor: 'brand.200' }}
          transition="all 0.2s"
          opacity={mod.status === 'coming-soon' ? 0.75 : 1}
        >
          <HStack gap={3} mb={2}>
            <Icon boxSize={6} color="accent" asChild><mod.icon /></Icon>
            <LinkOverlay asChild><RouterLink to={mod.basePath}>
                <Text fontWeight="semibold">{mod.label}</Text>
              </RouterLink></LinkOverlay>
            {mod.status === 'coming-soon' && (
              <Badge colorPalette="purple" fontSize="xs">
                Soon
              </Badge>
            )}
          </HStack>
          <Text fontSize="sm" color="gray.500">
            {mod.description}
          </Text>
        </LinkBox>
      ))}
    </SimpleGrid>
  );
}
